import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../../services';
import { PartnerService } from '../../../../services/partner.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-workshop-waivers',
  templateUrl: './workshop-waivers.component.html',
  styleUrls: ['./workshop-waivers.component.scss'],
})
export class WorkshopWaiversComponent implements OnInit {
  public selectedTab: string = 'WORKSHOP';
  public waiver: any = {};
  public loadingConfig: boolean = false;
  public savingConfig: boolean = false;

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService,
    private partnerService: PartnerService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.getWaiverConfig();
  }

  getWaiverConfig() {
    this.loadingConfig = true;
    this.partnerService
      .getWaiverConfig(this.helpersService.getPartnerId())
      .subscribe((res: any) => {
        this.waiver = res;
        this.loadingConfig = false;
      });
  }

  updateWaiver() {
    this.savingConfig = true;
    this.partnerService
      .updateWaiverConfig(this.waiver)
      .subscribe((res: any) => {
        this.waiver = res;
        this.savingConfig = false;

        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.rentals.configuration.updated_configuration',
          ),
        });
      });
  }
}
